import * as React from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import { cn } from "lib/utils";
import { ignoreToastInteractions } from "./toast";

// Bottom sheet (vaul): slides up from the bottom, drags down to dismiss. Sits
// above an open Dialog (z-[60]) so it can carry a dialog's detail settings.

const Drawer = ({ shouldScaleBackground = false, ...props }) => (
  <DrawerPrimitive.Root shouldScaleBackground={shouldScaleBackground} {...props} />
);
Drawer.displayName = "Drawer";

const DrawerPortal = DrawerPrimitive.Portal;
const DrawerClose = DrawerPrimitive.Close;

const DrawerOverlay = React.forwardRef(({ className, ...props }, ref) => (
  <DrawerPrimitive.Overlay
    ref={ref}
    className={cn("fixed inset-0 z-[60] bg-black/60", className)}
    {...props}
  />
));
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;

const DrawerContent = React.forwardRef(({ className, children, onInteractOutside, ...props }, ref) => (
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerPrimitive.Content
      ref={ref}
      className={cn(
        "fixed inset-x-0 bottom-0 z-[60] flex max-h-[85dvh] flex-col rounded-t-2xl border border-b-0 border-border bg-card pb-[env(safe-area-inset-bottom,0px)] outline-none",
        // A phone on its side (#227): a centred panel about half the width,
        // a little taller, instead of a strip across the whole screen.
        "phone-landscape:mx-auto phone-landscape:max-h-[92dvh] phone-landscape:w-full phone-landscape:max-w-xl",
        className,
      )}
      onInteractOutside={ignoreToastInteractions(onInteractOutside)}
      {...props}
    >
      <div
        aria-hidden="true"
        className="mx-auto mt-2.5 mb-1 h-1.5 w-10 shrink-0 rounded-full bg-muted-foreground/50"
      />
      {children}
    </DrawerPrimitive.Content>
  </DrawerPortal>
));
DrawerContent.displayName = "DrawerContent";

const DrawerTitle = React.forwardRef(({ className, ...props }, ref) => (
  <DrawerPrimitive.Title
    ref={ref}
    className={cn("text-base font-semibold text-center", className)}
    {...props}
  />
));
DrawerTitle.displayName = DrawerPrimitive.Title.displayName;

const DrawerDescription = React.forwardRef(({ className, ...props }, ref) => (
  <DrawerPrimitive.Description
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
));
DrawerDescription.displayName = DrawerPrimitive.Description.displayName;

export {
  Drawer,
  DrawerPortal,
  DrawerOverlay,
  DrawerClose,
  DrawerContent,
  DrawerTitle,
  DrawerDescription,
};
